<app-form-question-container [name]="name" [questionId]="questionId" [tooltip]="tooltip">
  @for (item of checkboxList; track item) {
    <mat-checkbox
      (change)="onOptionChange()"
      [value]="item.value"
      [disabled]="isDisabled || (selectedOptionsGroupId && selectedOptionsGroupId !== item.value.GroupId)"
      [(ngModel)]="item.selected"
      >
      {{ item.value.Name }}
    </mat-checkbox>
  }
</app-form-question-container>